import React, { useState } from 'react';
import PlanChangeModal from './PlanChangeModal';

const SubscriptionStatus = ({ subscription, availablePlans, onCancelSubscription, onUpdateSubscription }) => {
  const [showChangeModal, setShowChangeModal] = useState(false);

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Get status color
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'past_due':
        return 'bg-yellow-100 text-yellow-800';
      case 'canceled':
        return 'bg-red-100 text-red-800';
      case 'trialing':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="bg-white shadow-sm rounded-lg border border-gray-200 overflow-hidden">
      <div className="px-6 py-5 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-medium text-gray-900">
            {subscription.plan.name} Plan
          </h3>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(subscription.status)}`}>
            {subscription.status.charAt(0).toUpperCase() + subscription.status.slice(1)}
          </span>
        </div>
      </div>
      <div className="px-6 py-5">
        <dl className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-6">
          <div>
            <dt className="text-sm font-medium text-gray-500">Current billing period ends</dt>
            <dd className="mt-1 text-sm text-gray-900">{formatDate(subscription.current_period_end)}</dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-gray-500">Plan</dt>
            <dd className="mt-1 text-sm text-gray-900">{subscription.plan.name}</dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-gray-500">Users limit</dt>
            <dd className="mt-1 text-sm text-gray-900">
              {subscription.plan.max_users === null ? 'Unlimited users' : `${subscription.plan.max_users} users`}
            </dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-gray-500">Subscription status</dt>
            <dd className="mt-1 text-sm text-gray-900">
              {subscription.cancel_at_period_end ?
                'Canceled (access until end of billing period)' :
                subscription.status.charAt(0).toUpperCase() + subscription.status.slice(1)
              }
            </dd>
          </div>
        </dl>

        {!subscription.cancel_at_period_end && (
          <div className="mt-6 flex space-x-4">
            <button
              onClick={() => setShowChangeModal(true)}
              className="inline-flex items-center px-4 py-2 border border-blue-300 shadow-sm text-sm font-medium rounded-md text-blue-700 bg-white hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Change Plan
            </button>
            <button
              onClick={onCancelSubscription}
              className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Cancel Subscription
            </button>
          </div>
        )}
      </div>

      {/* Plan Change Modal */}
      <PlanChangeModal
        currentPlan={subscription.plan}
        availablePlans={availablePlans || []}
        isOpen={showChangeModal}
        onClose={() => setShowChangeModal(false)}
        onSuccess={onUpdateSubscription}
      />
    </div>
  );
};

export default SubscriptionStatus;